import React from 'react'
import { CallDark, Card1, Card10, Card11, Card12, Card13, Card2, Card3, Card4, Card5, Card6, Card7, Card8, Card9, Email, EmailDark, Facebook, Flights, Gift, GreenTick, Instagram, Linkedin, Lock, Logo, SupportCall, Twitter, Youtube } from '../assests/ExportImageIcon'
import { Link } from 'react-router-dom'
import './footer.css'

const Footer = () => {
    return (
        <>
            <footer className='paddingCmn pb-0'>
                <div className='container'>
                    <div className='row g-4'>
                        <div className='col-md-12'>
                            <div className='footerTop'>
                                <div className='footerLogo'>
                                    <img src={Logo} />
                                </div>
                                <div className='footerNav'>
                                    <ul>
                                        <li><Link to="/about-us">About Us</Link></li>
                                        <li><Link to="/">Our Mission</Link></li>
                                        <li><Link to="/">Our Vision</Link></li>
                                        <li><Link to="/">Our Team</Link></li>
                                        <li><Link to="/">Contact Us</Link></li>
                                        <li><Link to="/blog-listing">Blogs</Link></li>
                                        <li><Link to="/">24/7 Support</Link></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className='col-md-12'>
                            <div className='footerLinkArea'>
                                <div className='footerTitle'>Popular Flight Routes</div>
                                <div className='footerLinkInner'>
                                    <div className='footerLink'>
                                        <ul>
                                            <li><Link to="/">Delhi to Mumbai</Link></li>
                                            <li><Link to="/">Hyderabad to Delhi</Link></li>
                                            <li><Link to="/">Bangalore to Goa</Link></li>
                                            <li><Link to="/">Mumbai to Pune</Link></li>
                                        </ul>
                                    </div>
                                    <div className='footerLink'>
                                        <ul>
                                            <li><Link to="/">Mumbai to Bangalore</Link></li>
                                            <li><Link to="/">Kolkata to Delhi</Link></li>
                                            <li><Link to="/">Delhi to Jaipur</Link></li>
                                            <li><Link to="/">Bangalore to Chennai</Link></li>
                                        </ul>
                                    </div>
                                    <div className='footerLink'>
                                        <ul>
                                            <li><Link to="/">Delhi to Goa</Link></li>
                                            <li><Link to="/">Mumbai to Goa</Link></li>
                                            <li><Link to="/">Mumbai to Kolkata</Link></li>
                                            <li><Link to="/">Delhi to Srinagar</Link></li>
                                        </ul>
                                    </div>
                                    <div className='footerLink'>
                                        <ul>
                                            <li><Link to="/">Bangalore to Delhi</Link></li>
                                            <li><Link to="/">Delhi to Bangalore</Link></li>
                                            <li><Link to="/">Pune to Delhi</Link></li>
                                            <li><Link to="/">Mumbai to Ahmedabad</Link></li>
                                        </ul>
                                    </div>
                                    <div className='footerLink'>
                                        <ul>
                                            <li><Link to="/">Chennai to Mumbai</Link></li>
                                            <li><Link to="/">Mumbai to Chennai</Link></li>
                                            <li><Link to="/">Delhi to Chandigarh</Link></li>
                                            <li><Link to="/">Bangalore to Hyderabad</Link></li>
                                        </ul>
                                    </div>
                                </div>

                            </div>

                            <div className='footerLinkArea'>
                                <div className='footerTitle'>Hotels in Popular Cities</div>
                                <div className='footerLinkInner'>
                                    <div className='footerLink'>
                                        <ul>
                                            <li><Link to="/">Hotels in Goa</Link></li>
                                            <li><Link to="/">Hotels in Udaipur</Link></li>
                                            <li><Link to="/">Hotels in Kerala</Link></li>
                                            <li><Link to="/">Hotels in Pune</Link></li>
                                            <li><Link to="/">Hotels in Coorg</Link></li>
                                        </ul>
                                    </div>
                                    <div className='footerLink'>
                                        <ul>
                                            <li><Link to="/">Hotels in Mumbai</Link></li>
                                            <li><Link to="/">Hotels in Agra</Link></li>
                                            <li><Link to="/">Hotels in Rishikesh</Link></li>
                                            <li><Link to="/">Hotels in Hyderabad</Link></li>
                                            <li><Link to="/">Hotels in Munnar</Link></li>
                                        </ul>
                                    </div>
                                    <div className='footerLink'>
                                        <ul>
                                            <li><Link to="/">Hotels in Delhi</Link></li>
                                            <li><Link to="/">Hotels in Shimla</Link></li>
                                            <li><Link to="/">Hotels in Mussoorie</Link></li>
                                            <li><Link to="/">Hotels in Chennai</Link></li>
                                            <li><Link to="/">Hotels in Pondicherry</Link></li>
                                        </ul>
                                    </div>
                                    <div className='footerLink'>
                                        <ul>
                                            <li><Link to="/">Hotels in Bangalore</Link></li>
                                            <li><Link to="/">Hotels in Manali</Link></li>
                                            <li><Link to="/">Hotels in Darjeeling</Link></li>
                                            <li><Link to="/">Hotels in Kolkata</Link></li>
                                            <li><Link to="/">Hotels in Lonavala</Link></li>
                                        </ul>
                                    </div>
                                    <div className='footerLink'>
                                        <ul>
                                            <li><Link to="/">Hotels in Jaipur</Link></li>
                                            <li><Link to="/">Hotels in Ooty</Link></li>
                                            <li><Link to="/">Hotels in Nainital</Link></li>
                                            <li><Link to="/">Hotels in Mysore</Link></li>
                                        </ul>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div className='col-md-4'>
                            <div className='supportBox'>
                                <img src={SupportCall} className='left' />
                                <div className='content'>
                                    <div className='head'>24/7 Customer Support</div>
                                    <p>We're here to help you anytime, anywhere</p>
                                    {/* <Link to="tel:+91 1800-123-4567"><img src={CallDark} /> +91 1800-123-4567 (Toll Free)</Link> */}
                                    <Link to="tel:+91 120 687 0789"><img src={CallDark} /> +91 120 687 0789</Link>
                                    <Link to="mailto:support@travelbooking.com"><img src={EmailDark} /> support@travelbooking.com</Link>
                                </div>
                            </div>
                        </div>

                        <div className='col-md-4'>
                            <div className='supportBox'>
                                <img src={Gift} className='left' />
                                <div className='content'>
                                    <div className='head'>Award-Winning Platform</div>
                                    <p>Trusted by millions of travelers</p>
                                    <ul>
                                        <li>Best Travel Platform 2025</li>
                                        <li>10M+ Happy Customers</li>
                                        <li>4.5/5 Average Rating</li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div className='col-md-4'>
                            <div className='supportBox'>
                                <img src={Flights} className='left' />
                                <div className='content'>
                                    <div className='head'>Global Presence</div>
                                    <p>Serving travelers worldwide</p>
                                    <ul>
                                        <li>200+ Countries</li>
                                        <li>500+ Cities in India</li>
                                        <li>50,000+ Hotels</li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div className='col-md-6'>
                            <div className='supportBox supportBox2'>
                                <div className='content'>
                                    <div className='head'><img src={Email} /> Subscribe to Our Newsletter</div>
                                    <p>Get exclusive deals, travel inspiration, and insider tips delivered to your inbox. Join 5 million+ subscribers!</p>
                                    <div className='subs'>
                                        <input type='text' placeholder='Enter your email address' />
                                        <button className='commonBtn'>Subscribe</button>
                                    </div>
                                    <small>* By subscribing, you agree to receive marketing emails from TravelBook</small>
                                </div>
                            </div>
                        </div>

                        <div className='col-md-6'>
                            <div className='supportBox supportBox2'>
                                <div className='content'>
                                    <div className='head'>Connect With Us</div>
                                    <p>Follow us on social media for travel inspiration, deals, and updates</p>
                                    <div className='social'>
                                        <Link to="/"><img src={Facebook} /></Link>
                                        <Link to="/"><img src={Twitter} /></Link>
                                        <Link to="/"><img src={Instagram} /></Link>
                                        <Link to="/"><img src={Linkedin} /></Link>
                                        <Link to="/"><img src={Youtube} /></Link>
                                    </div>
                                    <small>Follow us for: <Link to="/">Travel Deals</Link> | <Link to="/">Tips & Guides</Link></small>
                                </div>
                            </div>
                        </div>

                        <div className='col-md-12'>
                            <div className='footerLinkArea'>
                                <div className='footerTitle'>We Accept</div>

                                <div className='paymentAccept'>
                                    <div className='paymentBox'><img src={Card1} /></div>
                                    <div className='paymentBox'><img src={Card2} /></div>
                                    <div className='paymentBox'><img src={Card3} /></div>
                                    <div className='paymentBox'><img src={Card4} /></div>
                                    <div className='paymentBox'><img src={Card5} /></div>
                                    <div className='paymentBox'><img src={Card6} /></div>
                                    <div className='paymentBox'><img src={Card7} /></div>
                                    <div className='paymentBox'><img src={Card8} /></div>
                                    <div className='paymentBox'><img src={Card9} /></div>
                                    <div className='paymentBox'><img src={Card10} /></div>
                                    <div className='paymentBox'><img src={Card11} /></div>
                                    <div className='paymentBox'><img src={Card12} /></div>
                                    <div className='paymentBox'><img src={Card13} /></div>
                                </div>

                                <div className='secure'>
                                    <div className='secureText'><img src={Lock} /> 100% Secure Payments</div>
                                    <div className='secureText'><img src={GreenTick} /> PCI DSS Certified</div>
                                    <div className='secureText'><img src={GreenTick} />  ISO 27001 Certified</div>
                                    <div className='secureText'><img src={GreenTick} />   SSL Encrypted</div>
                                </div>

                            </div>

                        </div>

                    </div>
                </div>
                <div className='footerBottom mt-5'>
                    <div className='container'>
                        <div className='top'>
                            <p>© 2026 TravelBooking Platform Pvt. Ltd. All rights reserved. CIN: U63040DL2015PTC123456</p>
                            <div className='link'>
                                <Link to="/">Sitemap</Link>
                                <Link to="/">Security</Link>
                                <Link to="/">Accessibility</Link>
                                <Link to="/">Cookie Preferences</Link>
                            </div>
                        </div>
                        <p><b>Registered Office</b>: Office No. 904, 9th Floor of Tower C Iconinc Correnthum Plot No. A-41, Sector-62, Noida, Dist: Gautam Budh Nagar - 201301</p>
                        <p>* Prices shown are base fares and exclude applicable taxes, fees, surcharges, and service charges unless otherwise stated. All bookings are subject to availability and confirmation. Baggage fees and other charges may apply for flights. Cancellation and date change charges as per airline/hotel/bus/train operator policies. Refund processing times may vary by vendor, payment method, and applicable terms. Please read all terms and conditions carefully before booking.</p>
                        <p>TravelBook is a leading travel booking platform in India offering flight tickets, hotel bookings, bus tickets, train reservations, car rentals, holiday packages, event tickets, and bill payment services across 500+ cities nationwide.</p>
                    </div>

                </div>
            </footer>
        </>
    )
}

export default Footer
